import { useQuery } from 'react-query';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';
import * as errorReporting from 'hb-react/shared/utils/errorReporting';

const fetchPage = ({ identifier }) =>
  axios
    .get(Routes.network_page_customizable_json_path(identifier))
    .then(({ data: { page_customizable: page } }) => page)
    .catch((err) => {
      errorReporting.captureException(err);
    });

const useFetchAppPage = ({ identifier }) => {
  const { data } = useQuery(
    `appPage_${identifier}`,
    () => fetchPage({ identifier }),
    {
      enabled: !!identifier,
      staleTime: 5 * 60 * 1000,
    },
  );

  return identifier ? data : null;
};

export default useFetchAppPage;
